import { SxStyleProp } from 'theme-ui';

export const styles = {
  button: {
    position: 'absolute',
    ml: ['16px !important', '16px !important', '16px !important', '0 !important'],
  } as SxStyleProp,
};
